import 'react-quill/dist/quill.snow.css';

import React from 'react';
import ReactQuill from 'react-quill';

function UpdateReleaseNoteEditor({
submitDisabled, setSubmitDisabled, releaseNotes, setReleaseNotes,
}) {
  const spanRef = React.useRef(null);

  const handleReleaseNotesChange = (e) => {
    const { value } = e.target;
    setReleaseNotes(value);
    if (value && value.length > 0) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }

    if (spanRef.current) {
      setSubmitDisabled(false);
      setSubmitDisabled(false);
  }
  };

  return (
    <div>
       <div>
          <ReactQuill
            value={releaseNotes}
            theme="snow"
            onChange={(newValue) => {
              const val = newValue === '<p><br></p>' ? '' : newValue;
              handleReleaseNotesChange({ target: { value: val } });
            }}
            readOnly={false}
            modules={{
              clipboard: {
                matchVisual: false,
              },
            }}
          />
       </div>
    </div>
  );
}

export default UpdateReleaseNoteEditor;
